import mustache from 'mustache';
import { timeDay } from 'd3-time';
import { timeFormat } from 'd3-time-format';

// Generate heds, deks, footnotes based on which forecast is selected
export default function generateCopy(forecast, manifestData) {
    if (!manifestData) return;
    if (manifestData) {
        const issuedDate = new Date(`${manifestData['forecasts']['day1-3'].START_TIME_UTC}Z`);
        const tomorrow = timeDay.offset(issuedDate, 1);
        const twoDay = timeDay.offset(issuedDate, 2);

        const tomorrowFormat = timeFormat('%A')(tomorrow);
        const twoDayFormat = timeFormat('%A')(twoDay);
       
    
        const mapper = {
            'day1-2': {
                headline: `${tomorrowFormat}'s forecast for precipitation`,
                subhed: "The National Weather Service's 48-hour forecast for precipitation.",
                legend: "Forecast precipitation (in)"
            }, 
            'day1-3': {
                headline: `${twoDayFormat}'s forecast for precipitation`,
                subhed: "The National Weather Service's 72-hour forecast for precipitation.",
                legend: "Forecast precipitation (in)"
            },
            '5day': {
                headline: `Five-day forecast for precipitation`,
                subhed: "The National Weather Service's 5-day forecast for precipitation.",
                legend: "Forecast precipitation (in)"
            },
            '7day': {
                headline: "Seven-day forecast for precipitation",
                subhed: "The National Weather Service's 7-day forecast for precipitation.",
                legend: "Forecast precipitation (in)"
            }
        }
        
        return mapper[forecast] || mapper['7day'];
    }
}